module.exports = __webpack_public_path__ + "static/media/icono_planner.a8596607.svg";